import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'
import { useMemo } from 'react'

import { getChangedSteps } from '../helpers/changedStep/getChangedSteps'

interface IProps {
  initialData: TEltFormData
  dataForSave: TEltFormData
  eltType?: EltType
  initialDataSettings?: string
  dataSettings?: string
}

export const useDetectChangedSteps = ({
  initialData,
  dataForSave,
  eltType = EltType.Pptx,
  initialDataSettings,
  dataSettings,
}: IProps) => {
  const changedSteps = useMemo(() => {
    let changedSteps = getChangedSteps({ initialData, dataForSave, eltType })

    const isSettingsChanged = JSON.stringify(initialDataSettings) !== JSON.stringify(dataSettings)
    if (isSettingsChanged) {
      changedSteps = isDocType(eltType)
        ? { ...changedSteps, 1: true, 2: true }
        : { ...changedSteps, 3: true, 4: true }
    }

    return changedSteps
  }, [initialDataSettings, dataSettings, initialData, dataForSave, eltType])

  return { changedSteps }
}
